/**
 * documentRepositoryUploadValidation.js — historia 170 (Repositorio Documental), J3. V8 (02-reglas.md):
 * fichero presente y con extensión; nombre de fichero ≤ 80 caracteres; tamaño ≤ MAX_FILE_SIZE; nombre
 * del documento no vacío; tipo de documento existente; mismo nombre + mismo fichero ya en ese
 * registro → se rechaza en pantalla (misma regla que `Document.jsx:26-34`). Pure functions, no JSX,
 * no i18n: `reason` is an i18n KEY (or `''` when valid — CLAUDE.md, never `null`/`undefined`);
 * `DocumentRepositoryUploadDialog.jsx` calls `t_(reason)`.
 */

/** 'despiece.pdf' -> {name:'despiece', extension:'pdf'}. No dot -> extension '' (never absent). */
export const extractFileNameParts = (fileName) => {
  const lastDot = fileName.lastIndexOf('.')
  if (lastDot <= 0) return { name: fileName, extension: '' }
  return { name: fileName.slice(0, lastDot), extension: fileName.slice(lastDot + 1) }
}

/** The `settings/MAX_FILE_SIZE` value (MB, or absent) -> bytes. Absent (`null`/`undefined`, the API
 * boundary shape of that endpoint) falls back to 1 GiB, same default as `Document.jsx`. */
export const parseMaxFileSizeBytes = (settingValue) => {
  if (settingValue === null || settingValue === undefined || settingValue === '') return 1024 * 1024 * 1024
  return parseInt(settingValue, 10) * 1024 * 1024
}

/**
 * V8, in the exact order the dialog checks it (fail on the first defect found). `existingDocuments`
 * is the R2 rows already associated with the chosen record (`{documentName, fileName, extension}`,
 * `fileName` WITHOUT extension per the frozen DTO — same shape as a `DocumentRepositoryEntryDto` row).
 */
export const validateUploadCandidate = ({ fileName, fileSize, documentName, documentTypeId, maxFileSizeBytes, existingDocuments }) => {
  const { name: candidateName, extension: candidateExtension } = extractFileNameParts(fileName)

  if (candidateExtension === '') return { valid: false, reason: 'The file has no extension' }
  if (fileName.length > 80) return { valid: false, reason: 'File name cannot exceed 80 characters' }
  if (fileSize > maxFileSizeBytes) return { valid: false, reason: 'File size exceeds the maximum limit' }
  if (documentName.trim() === '') return { valid: false, reason: 'Document name is required' }
  if (documentTypeId === '') return { valid: false, reason: 'Select a document type' }

  const isDuplicate = existingDocuments.some((document) =>
    document.documentName === documentName &&
    document.fileName === candidateName &&
    document.extension === candidateExtension.toUpperCase()
  )
  if (isDuplicate) return { valid: false, reason: 'Document with the same name and file already exists' }

  return { valid: true, reason: '' }
}
